var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48542 0.888444C7.00818 0.411209 6.23443 0.411209 5.75719 0.888444L0.510324 6.13531C0.0330169 6.61262 0.0330169 7.38649 0.510324 7.8638L5.75719 13.1107C6.23443 13.5879 7.00818 13.5879 7.48542 13.1107C7.96265 12.6334 7.96265 11.8597 7.48542 11.3824L3.96677 7.8638C3.48946 7.38649 3.48946 6.61262 3.96677 6.13531L7.48542 2.61667C7.96265 2.13943 7.96265 1.36568 7.48542 0.888444Z",
    fill: "#4C4E64",
    fillOpacity: 0.68
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8685 0.888444L6.62165 6.13531C6.14435 6.61262 6.14435 7.38649 6.62165 7.8638L11.8685 13.1107C12.3458 13.5879 13.1195 13.5879 13.5967 13.1107C14.074 12.6334 14.074 11.8597 13.5967 11.3824L10.0781 7.8638C9.60079 7.38649 9.60079 6.61262 10.0781 6.13531L13.5967 2.61667C14.074 2.13943 14.074 1.36568 13.5967 0.888444C13.1195 0.411209 12.3458 0.411209 11.8685 0.888444Z",
    fill: "#4C4E64",
    fillOpacity: 0.38
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.3feb6387d65e51c14d06e5f4062915c1.svg";
export { ForwardRef as ReactComponent };